/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TurniResDto } from '../../models/turni-res-dto';
import { UpdateTurnoDto } from '../../models/update-turno-dto';

export interface TurniControllerUpdateTurno$Params {
  idTurno: number;
  body: UpdateTurnoDto;
}

export function turniControllerUpdateTurno(
  http: HttpClient,
  rootUrl: string,
  params: TurniControllerUpdateTurno$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurniResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    turniControllerUpdateTurno.PATH,
    'patch',
  );
  if (params) {
    rb.path('idTurno', params.idTurno, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TurniResDto>;
      }),
    );
}

turniControllerUpdateTurno.PATH = '/admin/turni/id/{idTurno}';
